export class Verbs {
    static ABANDONED = {
        id: 'https://w3id.org/xapi/adl/verbs/abandoned',
        display: { 'en-US': 'abandoned' }
    };
    static ADJOURNED = {
        id: 'http://id.tincanapi.com/verb/adjourned',
        display: { 'en-US': 'adjourned' }
    };
    static ANSWERED = {
        id: 'http://adlnet.gov/expapi/verbs/answered',
        display: { 'en-US': 'answered' }
    };
    static APPLAUDED = {
        id: 'http://id.tincanapi.com/verb/applauded',
        display: { 'en-US': 'applauded' }
    };
    static ARRANGED = {
        id: 'http://id.tincanapi.com/verb/arranged',
        display: { 'en-US': 'arranged' }
    };
    static ASKED = {
        id: 'http://adlnet.gov/expapi/verbs/asked',
        display: { 'en-US': 'asked' }
    };
    static ATTEMPTED = {
        id: 'http://adlnet.gov/expapi/verbs/attempted',
        display: { 'en-US': 'attempted' }
    };
    static ATTENDED = {
        id: 'http://adlnet.gov/expapi/verbs/attended',
        display: { 'en-US': 'attended' }
    };
    static BOOKMARKED = {
        id: 'http://id.tincanapi.com/verb/bookmarked',
        display: { 'en-US': 'bookmarked' }
    };
    static CALLED = {
        id: 'http://id.tincanapi.com/verb/called',
        display: { 'en-US': 'called' }
    };
    static CLOSED_SALE = {
        id: 'http://id.tincanapi.com/verb/closed-sale',
        display: { 'en-US': 'closed sale' }
    };
    static COMMENTED = {
        id: 'http://adlnet.gov/expapi/verbs/commented',
        display: { 'en-US': 'commented' }
    };
    static COMPLETED = {
        id: 'http://adlnet.gov/expapi/verbs/completed',
        display: { 'en-US': 'completed' }
    };
    static CREATED_OPPORTUNITY = {
        id: 'http://id.tincanapi.com/verb/created-opportunity',
        display: { 'en-US': 'created opportunity' }
    };
    static DEFINED = {
        id: 'http://id.tincanapi.com/verb/defined',
        display: { 'en-US': 'defined' }
    };
    static DISABLED = {
        id: 'http://id.tincanapi.com/verb/disabled',
        display: { 'en-US': 'disabled' }
    };
    static DISCARDED = {
        id: 'http://id.tincanapi.com/verb/discarded',
        display: { 'en-US': 'discarded' }
    };
    static DOWNLOADED = {
        id: 'http://id.tincanapi.com/verb/downloaded',
        display: { 'en-US': 'downloaded' }
    };
    static EARNED = {
        id: 'http://id.tincanapi.com/verb/earned',
        display: { 'en-US': 'earned' }
    };
    static ENABLED = {
        id: 'http://id.tincanapi.com/verb/enabled',
        display: { 'en-US': 'enabled' }
    };
    static ENTERED_FRAME = {
        id: 'http://id.tincanapi.com/verb/frame/entered',
        display: { 'en-US': 'entered frame' }
    };
    static ESTIMATED_DURATION = {
        id: 'http://id.tincanapi.com/verb/estimated-duration',
        display: { 'en-US': 'estimated duration' }
    };
    static EXITED = {
        id: 'http://adlnet.gov/expapi/verbs/exited',
        display: { 'en-US': 'exited' }
    };
    static EXITED_FRAME = {
        id: 'http://id.tincanapi.com/verb/frame/exited',
        display: { 'en-US': 'exited frame' }
    };
    static EXPECTED = {
        id: 'http://id.tincanapi.com/verb/expected',
        display: { 'en-US': 'expected' }
    };
    static EXPERIENCED = {
        id: 'http://adlnet.gov/expapi/verbs/experienced',
        display: { 'en-US': 'experienced' }
    };
    static EXPIRED = {
        id: 'http://id.tincanapi.com/verb/expired',
        display: { 'en-US': 'expired' }
    };
    static FAILED = {
        id: 'http://adlnet.gov/expapi/verbs/failed',
        display: { 'en-US': 'failed' }
    };
    static FOCUSED = {
        id: 'http://id.tincanapi.com/verb/focused',
        display: { 'en-US': 'focused' }
    };
    static HIRED = {
        id: 'http://id.tincanapi.com/verb/hired',
        display: { 'en-US': 'hired' }
    };
    static INITIALIZED = {
        id: 'http://adlnet.gov/expapi/verbs/initialized',
        display: { 'en-US': 'initialized' }
    };
    static IMPORTED = {
        id: 'http://adlnet.gov/expapi/verbs/imported',
        display: { 'en-US': 'imported' }
    };
    static INTERACTED = {
        id: 'http://adlnet.gov/expapi/verbs/interacted',
        display: { 'en-US': 'interacted' }
    };
    static INTERVIEWED = {
        id: 'http://id.tincanapi.com/verb/interviewed',
        display: { 'en-US': 'interviewed' }
    };
    static LAUNCHED = {
        id: 'http://adlnet.gov/expapi/verbs/launched',
        display: { 'en-US': 'launched' }
    };
    static LOGGED_IN = {
        id: 'https://w3id.org/xapi/adl/verbs/logged-in',
        display: { 'en-US': 'logged-in' }
    };
    static LOGGED_OUT = {
        id: 'https://w3id.org/xapi/adl/verbs/logged-out',
        display: { 'en-US': 'logged-out' }
    };
    static LAUGHED = {
        id: 'http://id.tincanapi.com/verb/laughed',
        display: { 'en-US': 'laughed' }
    };
    static MARKED_AS_UNREAD = {
        id: 'http://id.tincanapi.com/verb/marked-unread',
        display: { 'en-US': 'marked as unread' }
    };
    static MASTERED = {
        id: 'http://adlnet.gov/expapi/verbs/mastered',
        display: { 'en-US': 'mastered' }
    };
    static MENTIONED = {
        id: 'http://id.tincanapi.com/verb/mentioned',
        display: { 'en-US': 'mentioned' }
    };
    static MENTORED = {
        id: 'http://id.tincanapi.com/verb/mentored',
        display: { 'en-US': 'mentored' }
    };
    static PASSED = {
        id: 'http://adlnet.gov/expapi/verbs/passed',
        display: { 'en-US': 'passed' }
    };
    static PAUSED = {
        id: 'https://w3id.org/xapi/adl/verbs/paused',
        display: { 'en-US': 'paused' }
    };
    static PERFORMED_OFFLINE = {
        id: 'http://id.tincanapi.com/verb/performed-offline',
        display: { 'en-US': 'performed offline' }
    };
    static PERSONALIZED = {
        id: 'http://id.tincanapi.com/verb/personalized',
        display: { 'en-US': 'personalized' }
    };
    static PLAYED = {
        id: 'https://w3id.org/xapi/adl/verbs/played',
        display: { 'en-US': 'played' }
    };
    static PREFERRED = {
        id: 'http://adlnet.gov/expapi/verbs/preferred',
        display: { 'en-US': 'preferred' }
    };
    static PREVIEWED = {
        id: 'http://id.tincanapi.com/verb/previewed',
        display: { 'en-US': 'previewed' }
    };
    static PROGRESSED = {
        id: 'http://adlnet.gov/expapi/verbs/progressed',
        display: { 'en-US': 'progressed' }
    };
    static PROMOTED = {
        id: 'http://id.tincanapi.com/verb/promoted',
        display: { 'en-US': 'promoted' }
    };
    static RATED = {
        id: 'http://id.tincanapi.com/verb/rated',
        display: { 'en-US': 'rated' }
    };
    static REGISTERED = {
        id: 'http://adlnet.gov/expapi/verbs/registered',
        display: { 'en-US': 'registered' }
    };
    static REPLIED = {
        id: 'http://id.tincanapi.com/verb/replied',
        display: { 'en-US': 'replied' }
    };
    static REPLIED_TO_TWEET = {
        id: 'http://id.tincanapi.com/verb/replied-to-tweet',
        display: { 'en-US': 'replied to tweet' }
    };
    static REQUESTED_ATTENTION = {
        id: 'http://id.tincanapi.com/verb/requested-attention',
        display: { 'en-US': 'requested attention' }
    };
    static RESPONDED = {
        id: 'http://adlnet.gov/expapi/verbs/responded',
        display: { 'en-US': 'responded' }
    };
    static RESUMED = {
        id: 'http://adlnet.gov/expapi/verbs/resumed',
        display: { 'en-US': 'resumed' }
    };
    static RETWEETED = {
        id: 'http://id.tincanapi.com/verb/retweeted',
        display: { 'en-US': 'retweeted' }
    };
    static REVIEWED = {
        id: 'http://id.tincanapi.com/verb/reviewed',
        display: { 'en-US': 'reviewed' }
    };
    static SATISFIED = {
        id: 'https://w3id.org/xapi/adl/verbs/satisfied',
        display: { 'en-US': 'satisfied' }
    };
    static SCORED = {
        id: 'http://adlnet.gov/expapi/verbs/scored',
        display: { 'en-US': 'scored' }
    };
    static SECURED = {
        id: 'http://id.tincanapi.com/verb/secured',
        display: { 'en-US': 'secured' }
    };
    static SEEKED = {
        id: 'https://w3id.org/xapi/adl/verbs/seeked',
        display: { 'en-US': 'seeked' }
    };
    static SELECTED = {
        id: 'http://id.tincanapi.com/verb/selected',
        display: { 'en-US': 'selected' }
    };
    static SHARED = {
        id: 'http://adlnet.gov/expapi/verbs/shared',
        display: { 'en-US': 'shared' }
    };
    static SKIPPED = {
        id: 'http://id.tincanapi.com/verb/skipped',
        display: { 'en-US': 'skipped' }
    };
    static SUSPENDED = {
        id: 'http://adlnet.gov/expapi/verbs/suspended',
        display: { 'en-US': 'suspended' }
    };
    static TALKEDWITH = {
        id: 'http://id.tincanapi.com/verb/talked-with',
        display: { 'en-US': 'talkedwith' }
    };
    static TERMINATED = {
        id: 'http://adlnet.gov/expapi/verbs/terminated',
        display: { 'en-US': 'terminated' }
    };
    static TWEETED = {
        id: 'http://id.tincanapi.com/verb/tweeted',
        display: { 'en-US': 'tweeted' }
    };
    static UNFOCUSED = {
        id: 'http://id.tincanapi.com/verb/unfocused',
        display: { 'en-US': 'unfocused' }
    };
    static UNREGISTERED = {
        id: 'http://id.tincanapi.com/verb/unregistered',
        display: { 'en-US': 'unregistered' }
    };
    static VOIDED = {
        id: 'http://adlnet.gov/expapi/verbs/voided',
        display: { 'en-US': 'voided' }
    };
    static VOTED_DOWN = {
        id: 'http://id.tincanapi.com/verb/voted-down',
        display: { 'en-US': 'voted down' }
    };
    static VOTED_UP = {
        id: 'http://id.tincanapi.com/verb/voted-up',
        display: { 'en-US': 'voted up' }
    };
    static VIEWED = {
        id: 'http://id.tincanapi.com/verb/viewed',
        display: { 'en-US': 'viewed' }
    };
    static WAIVED = {
        id: 'https://w3id.org/xapi/adl/verbs/waived',
        display: { 'en-US': 'waived' }
    };
}
